<!--go-chat-duplication-->
<div [ngStyle]="{'width': diameter, 'height': diameter}">
</div>
